import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerHeadlineConverter extends CmsConverterService<CongressContainerHeadlineData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      spacing: {
        bottom: formData.st_spacing_bottom?.value?.identifier ?? '',
        top: formData.st_spacing_top?.value?.identifier ?? ''
      },
      center: formData.st_center_headline?.value ?? false,
    }
  }
}

export const CONGRESS_CONTAINER_HEADLINE_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CongressContainerHeadlineData>>('CongressContainerHeadlineConverter')

export interface CongressContainerHeadlineData extends ConvertedComponentData {
  headline: TextInput;
  spacing: Spacing;
  center: boolean;
}
